import { useEffect } from "react";
import { type TranscriptTabProps } from "./types";
import { trellisPalette } from "components/custom/analytics/palettes";
import { css } from "../../../styled-system/css";

const TranscriptTab = ({ content, file_id, timeValue }: TranscriptTabProps) => {
  useEffect(() => {
    if (timeValue && file_id) {
      const highlightId = `id=${file_id}&time=${timeValue}`;
      const el = document.getElementById(highlightId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [file_id, timeValue]);
  const turns = content.split(/(?=\d{2}:\d{2}:\d{2} - )/g);
  return (
    <div>
      {turns.map((turn, idx) => {
        const temp = turn.split(" - ")[1]?.split(/\n(.+)/s);
        const timeValue = turn.split(" - ")[0];
        const speakerLine = temp?.[0]?.trim();
        const message = temp?.[1]?.trim();

        return (
          <div
            key={idx}
            className={css({
              display: "flex",
              justifyContent: speakerLine?.includes("Trellis") ? "flex-end" : "flex-start",
              marginBottom: "10px",
              fontSize: "small",
            })}
          >
            <a id={`id=${file_id}&time=${timeValue}`} />
            <div
              className={css({
                display: "flex",
                flexDirection: "column",
                borderRadius: "5px",
                maxWidth: "40%",
                padding: "2rem",

                boxShadow: "md",
              })}
              style={{ backgroundColor: speakerLine?.includes("Trellis") ? trellisPalette[2] : trellisPalette[11] }}
            >
              <div
                className={css({
                  color: speakerLine?.includes("Trellis") ? "white" : "#111",
                  fontSize: "medium",
                  fontWeight: "bold",
                })}
              >
                {timeValue} - {speakerLine}
              </div>
              <div style={{ color: speakerLine?.includes("Trellis") ? "white" : "#111" }}>{message}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TranscriptTab;
